import React from 'react';
import { Box } from '@qga/roo-ui/components';
import PropTypes from 'prop-types';

import Alert from '@/components/Alert';
import Text from '@/components/Text';
import useDestination from '../../../../hooks/useDestination';

const NoResults = ({ children }) => {
  const destination = useDestination();
  return (
    <Alert.Warning>
      <Box>
        <Text bold>{`We can't find your ${destination.title} holiday.`}</Text>
        {children && <Box data-testid="CHILDREN">{children}</Box>}
      </Box>
    </Alert.Warning>
  );
};

NoResults.propTypes = {
  children: PropTypes.node,
};

export default NoResults;
